import { useEffect, useRef } from "react";

export default function useAccessibleFocus(isShow = true, inputRef = null) {
  const ref = inputRef || useRef(null);

  useEffect(() => {
    if (ref.current && isShow) {
      // Try to focus without scrolling the page (supported in modern browsers)
      try {
        ref.current.focus({ preventScroll: true });
      } catch (e) {
      // Fallback for browsers that don't support the option
        ref.current.focus();
      }
    }
  }, [isShow]);

  return ref;
}